export function getOS() {
    return window.navigator.userAgent
}

